import * as goldenrush from './RaceTypeAvailable.styles.goldenrush';
import * as juicybet from './RaceTypeAvailable.styles.juicybet';
import * as vikingbet from './RaceTypeAvailable.styles.vikingbet';
import * as sterlingparker from './RaceTypeAvailable.styles.sterlingparker';
import * as slambet from './RaceTypeAvailable.styles.slambet';
import * as gigabet from './RaceTypeAvailable.styles.gigabet';
import * as goldenbet888 from './RaceTypeAvailable.styles.goldenbet888';
import * as betgalaxy from './RaceTypeAvailable.styles.betgalaxy';
import * as hyperbet from './RaceTypeAvailable.styles.hyperbet';
import * as bet777 from './RaceTypeAvailable.styles.bet777';
import * as fiestabet from './RaceTypeAvailable.styles.fiestabet';
import * as wellbet from './RaceTypeAvailable.styles.wellbet';
import * as oldgill from './RaceTypeAvailable.styles.oldgill';
import * as betroyale from './RaceTypeAvailable.styles.betroyale';
import * as junglebet from './RaceTypeAvailable.styles.junglebet';
import * as chromabet from './RaceTypeAvailable.styles.chromabet';
import * as betprofessor from './RaceTypeAvailable.styles.betprofessor';
import * as bet575 from './RaceTypeAvailable.styles.bet575';
import * as puntcity from './RaceTypeAvailable.styles.puntcity';
import * as volcanobet from './RaceTypeAvailable.styles.volcanobet';
import * as templebet from './RaceTypeAvailable.styles.templebet';
import * as sugarcastle from './RaceTypeAvailable.styles.sugarcastle';
import * as epicodds from './RaceTypeAvailable.styles.epicodds';
import * as questbet from './RaceTypeAvailable.styles.questbet';
import * as puntgenie from './RaceTypeAvailable.styles.puntgenie';
import * as buffalobet from './RaceTypeAvailable.styles.buffalobet';
import * as titanbet from './RaceTypeAvailable.styles.titanbet';
import * as pyramidbet from './RaceTypeAvailable.styles.pyramidbet';
import * as magnumbet from './RaceTypeAvailable.styles.magnumbet';
import * as betstride from './RaceTypeAvailable.styles.betstride';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  vikingbet,
  sterlingparker,
  slambet,
  gigabet,
  goldenbet888,
  betgalaxy,
  hyperbet,
  bet777,
  fiestabet,
  wellbet,
  oldgill,
  betroyale,
  junglebet,
  chromabet,
  betprofessor,
  bet575,
  puntcity,
  volcanobet,
  templebet,
  sugarcastle,
  epicodds,
  questbet,
  puntgenie,
  buffalobet,
  titanbet,
  pyramidbet,
  magnumbet,
  betstride,
};
